import { defineComponent as _defineComponent } from 'vue'
import { onMounted, reactive, ref } from "vue";

import DOMPurify from "dompurify";
import showdown from "showdown";
import { get_cookie } from "@/cookie";

type PropTypes = {
  messages?: ReadonlyArray<Readonly<Message>>;
};

interface Message {
  for_version: string;
  text: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'dev_to_user_messages',
  props: {
    messages: { default: [] as ReadonlyArray<Readonly<Message>> }
  },
  setup(__props: any) {

const props = __props as { messages: ReadonlyArray<Readonly<Message>> };

const converter = new showdown.Converter();



const state = reactive<{ to_display: Message[] }>({
  to_display: [],
});

onMounted(() => {
  // Display nothing if we're running e2e tests
  if (get_cookie('E2E_TEST_MODE') === 'true') {
    return;
  }

  for (const message of props.messages ?? []) {
    if (!was_dismissed(message)) {
      state.to_display.push(message);
    }
  }
});

function as_markdown(message: Message) {
  return DOMPurify.sanitize(<string>converter.makeHtml(message.text));
}

function dismiss_message(message: Message) {
  localStorage.setItem(get_message_id(message), "dismissed");
  state.to_display.splice(state.to_display.indexOf(message), 1);
}

function was_dismissed(message: Message) {
  return localStorage.getItem(get_message_id(message)) !== null;
}

function get_message_id(message: Message) {
  return message.for_version + " " + message.text;
}

return { __sfc: true,converter, props, state, as_markdown, dismiss_message, was_dismissed, get_message_id }
}

})